<template>
  <heading
    :modifiers="['v2-overflow']"
    background="banner-store"
    class="stores-page__header overflow-visible pb-0 items-start">
    <template #title>
      Nos magasins
    </template>

    <template #baseline>
      Potager&nbsp;City, primeur&nbsp;de&nbsp;quartier et&nbsp;dénicheurs&nbsp;de&nbsp;bon.
    </template>
  </heading>

  <div class="bg-beryl-green">
    <potager-container>
      <div
        class="flex relative bg-bianca rounded-xl overflow-hidden max-h-[85vh] h-[800px] bp840:h-[650px] bp640:h-[550px] shadow-2xl">
        <dlp-stores-list v-if="!$potagerRoute?.meta?.isPanel" v-show="!$mq.bp768 || isListVisible" />

        <dlp-map-stores
          v-if="!$potagerRoute?.meta?.isPanel" />
      </div>

      <div class="py-[100px] text-center">
        <h2 class="text-4xl font-bold mb-8">
          Le meilleur du marché dans votre quartier
        </h2>

        <div class="grid grid-cols-4 gap-8 bp840:grid-cols-2 bp425:grid-cols-1">
          <div
            v-for="({ icon, title, description }, index) in CEOContent"
            :key="`ceo-content-${index}`"
            class="flex flex-col items-center">
            <component :is="icon" class="text-[100px] mb-5" />

            <h3 class="font-lore-alternates text-2xl font-bold mb-2">
              {{ title }}
            </h3>

            <span class="text-charcoal bloc mt-auto">
            {{ description }}
          </span>
          </div>
        </div>
      </div>
    </potager-container>

    <div class="overflow-hidden relative w-full bg-white">
      <div class="flex animate-scroll w-[4800px] bp840:w-[3600px] bp425:w-[2400px] gap-[1px]">
        <template v-for="i in 3">
          <potager-picture
            v-for="id in [1, 2, 3, 4]"
            :key="`stores-slide-${i}-${id}`"
            :src="`stores-slide-${id}`"
            :width="$mq.bp425 ? 200 : $mq.bp840 ? 300 : 400"
            alt="Illustration Potager City"
            noLazyLoad />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import PotagerPicture from 'UI/PotagerPicture';
import PotagerContainer from 'UI/PotagerContainer';

import Heading from 'Components/heading/Heading';
import DlpMapStores from 'Components/deliveryPoint/map/DlpMapStores';
import DlpList from 'Components/deliveryPoint/DlpList';
import DlpStoresList from 'Components/deliveryPoint/DlpStoresList';
import DlpListSwitcher from 'Components/deliveryPoint/DlpListSwitcher';

import MetaInfoService from 'Classes/services/MetaInfoService';

import IconIlluFruitsEtLegumes from 'Icons/graphics/IconIlluFruitsEtLegumes';
import IconIlluCookiesAndSauces from 'Icons/graphics/IconIlluCookiesAndSauces';
import IconIlluMilk from 'Icons/graphics/IconIlluMilk';
import IconIlluBeersAndWines from 'Icons/graphics/IconIlluBeersAndWines';

export default {
  name: 'ManifestoPage',

  data() {
    return {
      CEOContent: [
        {
          icon: IconIlluFruitsEtLegumes,
          title: 'Fruits & légumes',
          description: 'Le meilleur du fruit et du légume de saison, livrés chaque jour dans votre magasin.',
        },
        {
          icon: IconIlluCookiesAndSauces,
          title: 'Épicerie',
          description: 'Un large assortiment de produits finement sélectionnés, du petit dej’  à l’apéritif.',
        },
        {
          icon: IconIlluMilk,
          title: 'Produits frais',
          description: 'Une sélection gourmande de charcuterie et de fromages AOP grâce aux bons éleveurs & affineurs.',
        },
        {
          icon: IconIlluBeersAndWines,
          title: 'Vins & Bières',
          description: 'Des bouteilles pour les curieux et pour les plus initiés, de la bière parisienne au Bourgogne de choix.',
        }
      ],
    };
  },

  components: {
    PotagerContainer,
    DlpListSwitcher,
    DlpStoresList,
    DlpList,
    DlpMapStores,
    PotagerPicture,
    Heading,
    IconIlluFruitsEtLegumes,
    IconIlluCookiesAndSauces,
    IconIlluMilk,
    IconIlluBeersAndWines,
  },

  computed: {
    ...mapGetters('map', [
      'isListVisible',
    ]),
  },

  head() {
    return MetaInfoService.generate({
      title: 'Nos magasins',
      description: 'Potager City, primeur de quartier et dénicheurs de bon.',
    }, this.$route);
  },
};
</script>

<style lang="scss" scoped>
.stores-page {
  :deep() .heading__container {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  &__header {
    @apply bg-beryl-green;
  }
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-1600px);
  }
}

@include bp840() {
  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-1200px);
    }
  }
}

@include bp425() {
  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-800px);
    }
  }
}

.animate-scroll {
  animation: scroll 20s linear infinite;
}
</style>
